import React from 'react'
import Form from '../../../components/common/Form'
import formConfig from "../../../formJsonData/Collections/CreditNote/CreditNoteForm.json"
const AddCreditNote = () => {
  return (
    <div>
      <Form formConfig={formConfig} />
    </div>
  )
}

export default AddCreditNote
